function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9999 53.3334C20.2399 53.3334 10.6666 43.76 10.6666 32C10.6666 20.24 20.2399 10.6667 31.9999 10.6667C43.7599 10.6667 53.3333 20.24 53.3333 32C53.3333 43.76 43.7599 53.3334 31.9999 53.3334ZM31.9999 5.33337C28.498 5.33337 25.0304 6.02313 21.795 7.36325C18.5597 8.70338 15.62 10.6676 13.1437 13.1439C8.14277 18.1448 5.33325 24.9276 5.33325 32C5.33325 39.0725 8.14277 45.8553 13.1437 50.8562C15.62 53.3325 18.5597 55.2967 21.795 56.6368C25.0304 57.977 28.498 58.6667 31.9999 58.6667C39.0724 58.6667 45.8551 55.8572 50.8561 50.8562C55.8571 45.8553 58.6666 39.0725 58.6666 32C58.6666 28.4981 57.9768 25.0305 56.6367 21.7951C55.2966 18.5598 53.3323 15.6201 50.8561 13.1439C48.3799 10.6676 45.4402 8.70338 42.2048 7.36325C38.9695 6.02313 35.5018 5.33337 31.9999 5.33337V5.33337ZM26.6666 44L42.6666 32L26.6666 20V44Z",
  fill: "#f60"
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.dad714a5.svg";
export { ForwardRef as ReactComponent };